import NewRequestDataFormKeys from "../keys";
import NewRequestDataConfig from "../types";

const fieldsToShow = [
    NewRequestDataFormKeys.INSURED_FULLNAME,
    NewRequestDataFormKeys.ACTIVITY,
    NewRequestDataFormKeys.ADDRESS,
    NewRequestDataFormKeys.MAP,
    NewRequestDataFormKeys.COUNTRY,
    NewRequestDataFormKeys.PROVINCE,
    NewRequestDataFormKeys.CITY,
    NewRequestDataFormKeys.ZIPCODE,
    NewRequestDataFormKeys.BUILDING,
    NewRequestDataFormKeys.BUSINESS_INTERRUPTION,
    NewRequestDataFormKeys.CONTENT,
    NewRequestDataFormKeys.TOTAL_SUM_SECURED,
    NewRequestDataFormKeys.FLOORS,
    NewRequestDataFormKeys.YEARBUILT,
    NewRequestDataFormKeys.BEACHFRONT,
];

const previewFields = [
    NewRequestDataFormKeys.INSURED_FULLNAME,
    NewRequestDataFormKeys.ACTIVITY,
    NewRequestDataFormKeys.TOTAL_SUM_SECURED,
    NewRequestDataFormKeys.VALIDITY_FROM,
    NewRequestDataFormKeys.VALIDITY_TO,
];

const config: NewRequestDataConfig = {
    fieldsToShow,
    previewFields,
};

export default config;